export enum CategoryFilter {
  Video = 'video',
  Files = 'files',
  ELearning = 'eLearning'
}
